import React from 'react';

interface FilterItemProps {
  children: React.ReactElement | React.ReactElement[];
}

const FilterItem = (props: FilterItemProps): React.ReactElement => {
  return <div className="filters__item">{props.children}</div>;
};

export default FilterItem;
